import { render, staticRenderFns } from "./switches.vue?vue&type=template&id=8e4870fc&"
import script from "./switches.vue?vue&type=script&lang=js&"
export * from "./switches.vue?vue&type=script&lang=js&"
import style0 from "./../dist/switches.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports